import { useEffect, useState } from 'react';

import { servGetModelosItemFormularioPorBloco } from '../../servicos/servicosEmRotasPrivadas/modelo_item_formulario';

function SelectModeloItemFormularioControlled({ id, value, blocoItemId, onChange }) {

    console.log('### Iniciando SelectModeloItemFormulario ###');
    console.log('DEBUG', blocoItemId);
    
    
    const [modeloItemList, setModeloItemList] = useState([])

    useEffect(() => {
        getModelosItemFormularioPorBloco()
    }, [blocoItemId]);

    const getModelosItemFormularioPorBloco = async () => {
        try {
            const modelosDaApi = await servGetModelosItemFormularioPorBloco(blocoItemId)
            setModeloItemList(modelosDaApi)
        } catch (erro) {
            console.log(erro);
        }
    }

    return (
        <div>
            {modeloItemList ? (
                <div className="d-flex flex-column flex-md-row gap-1 p-1 align-items-center">
                    <select
                        className="form-control-sm w-100"
                        defaultValue={value || ''}
                        onChange={(e) => onChange(e.target.value || null)}
                    >
                        <option value="">Selecione uma opção</option>
                        {modeloItemList.map((modelo) => (
                            <option key={modelo.id} value={modelo.id}>
                                {modelo.bloco_item_formulario_id}.{modelo.codigo} - {modelo.descricao}
                            </option>
                        ))}
                    </select>
                </div>
            ) : (
                <p>Carregando informações dos modelos (perguntas)...</p>
            )}
        </div>
    )
}

export default SelectModeloItemFormularioControlled